"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function handleSelectBlur(e, _a) {
    var actions = _a.actions, state = _a.state, config = _a.config;
    if (state.isKeying)
        return;
    actions.blur();
    if (config.behavior.openOnFocus && !state.isClickSelecting)
        actions.close();
}
exports.default = handleSelectBlur;
//# sourceMappingURL=handleSelectBlur.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/Eoo/Repositories/legance/wp-content/themes/legance/node_modules/easydropdown/dist/Events/Handlers/handleSelectBlur.js
// module id = 62
// module chunks = 0